import { render } from "./adminbreadcrumb4.vue?vue&type=template&id=03e5df94"
import script from "./adminbreadcrumb4.vue?vue&type=script&lang=js"
export * from "./adminbreadcrumb4.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__